import get from 'lodash/get';
import getFields from './getFields';
const getFieldsByQuery = (query, ION, searchHidden = false) => {
    if (!ION) {
        return null;
    }
    if (!query) {
        return [];
    }
    const [key] = Object.keys(query);
    const fields = getFields(ION, searchHidden);
    const viewFields = fields.filter((field) => get(field, key) === query[key]);
    return viewFields;
};
export default getFieldsByQuery;
